import { axiosInstance, setAxiosAuthorization } from '~/common/utils/api.util.ts';
import { getCookie, removeCookie, setCookie } from '~/common/utils/cookie.util.ts';
import { TOKEN_KEY } from '~/features/auth/data/cookie.data.ts';

export function getAccessToken() {
  return getCookie(TOKEN_KEY);
}

export function setAuthData(accessToken: string) {
  setCookie(TOKEN_KEY, accessToken, {
    path: '/',
    expires: 30,
  });
  setAxiosAuthorization(axiosInstance, accessToken);
}

export function resetAuthData() {
  removeCookie(TOKEN_KEY);
  setAxiosAuthorization(axiosInstance, null);
}
